import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Suppress ResizeObserver loop errors (benign in this context)
const resizeObserverLoopErr = 'ResizeObserver loop completed with undelivered notifications';
const originalError = console.error;
console.error = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes(resizeObserverLoopErr)) {
    return;
  }
  originalError.call(console, ...args);
};

window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
    e.message === 'ResizeObserver loop limit exceeded') {
    e.stopImmediatePropagation();
  }
});

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

